import API from '@/models/API';

export default class Redemptions {
  constructor(item = {}) {}

  static get = (query) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/gifts-to-suppliers${query}`);

  static getVouchers = (query) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/gifts-to-suppliers/vouchers${query}`);

  static getAllGifts = (query) =>
    API.get(
      `/companies/${localStorage.getItem('storeId')}/gifts-to-suppliers/company-all-vouchers${query}`
    );

  static getSuppliers = () => API.get(`/companies/${localStorage.getItem('storeId')}/suppliers`);

  static cancelGift = (id) =>
    API.post(
      `/companies/${localStorage.getItem('storeId')}/gifts-to-suppliers/cancel-coupon-claim`,
      { transaction_id: id }
    );
}
